import ApiService from "../api";

export default class MargemService extends ApiService {

    constructor() {
        super("/api/margem");
    }

    /**
     * Cria ou atualiza margem
     */
    salvar(data) {
        return this.post("", data);
    }

    /**
     * Busca margem por filial e ano
     */
    buscarPorFilialEAno(filialId, ano) {
        return this.get(`/filial/${filialId}/ano/${ano}`);
    }

    /**
     * Lista margens do ano
     */
    listarPorAno(ano) {
        return this.get(`/ano/${ano}`);
    }

    /**
     * Remove margem
     */
    deletar(id) {
        return this.delete(`/${id}`);
    }
}